import React from "react";
import { TID } from "@/lib/testIds";
import { portfolioApi } from "@/lib/api";
import { Download } from "lucide-react";

export default function TradeHistory({ trades }) {
  const hasTrades = (trades?.length || 0) > 0;
  return (
    <div className="aq-card p-4">
      <div className="mb-3 flex items-center justify-between">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Activity</div>
          <div className="font-display text-lg font-bold mt-0.5">Trade history</div>
        </div>
        <div className="flex items-center gap-3">
          <div className="font-mono text-[10px] text-slate-500">{trades?.length || 0} trades</div>
          <a
            data-testid="trade-history-export-csv"
            href={portfolioApi.csvUrl()}
            download
            aria-disabled={!hasTrades}
            onClick={(e) => { if (!hasTrades) e.preventDefault(); }}
            className={`inline-flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest px-2.5 py-1.5 rounded-full border transition ${
              hasTrades
                ? "border-emerald-500/40 bg-emerald-500/10 text-emerald-300 hover:bg-emerald-500/20"
                : "border-white/10 bg-white/5 text-slate-500 cursor-not-allowed"
            }`}
            title={hasTrades ? "Download all trades as CSV" : "No trades to export yet"}
          >
            <Download className="w-3 h-3" /> csv
          </a>
        </div>
      </div>
      <div className="overflow-x-auto aq-scroll">
        <table className="w-full text-sm min-w-[720px]">
          <thead>
            <tr className="text-left font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 border-b border-white/5">
              <th className="py-2 pr-4">Time</th>
              <th className="py-2 pr-4">Symbol</th>
              <th className="py-2 pr-4">Side</th>
              <th className="py-2 pr-4">Qty</th>
              <th className="py-2 pr-4">Price</th>
              <th className="py-2 pr-4">Value</th>
              <th className="py-2 pr-4">Source</th>
            </tr>
          </thead>
          <tbody>
            {(!trades || trades.length === 0) && (
              <tr><td colSpan={7} className="py-8 text-center text-slate-500 font-mono text-xs">No trades yet — fire a scan or place a manual order.</td></tr>
            )}
            {trades?.map((t) => (
              <tr key={t.trade_id} data-testid={TID.tradeHistoryRow(t.trade_id)} className="border-b border-white/5 hover:bg-white/5">
                <td className="py-2 pr-4 font-mono text-xs text-slate-400">{new Date(t.executed_at).toLocaleString()}</td>
                <td className="py-2 pr-4 font-display font-bold">{t.symbol}</td>
                <td className={`py-2 pr-4 font-mono font-semibold ${t.side === "BUY" ? "text-emerald-300" : "text-rose-300"}`}>{t.side}</td>
                <td className="py-2 pr-4 font-mono">{t.quantity}</td>
                <td className="py-2 pr-4 font-mono">${t.price}</td>
                <td className="py-2 pr-4 font-mono">${t.value.toLocaleString()}</td>
                <td className="py-2 pr-4">
                  {(() => {
                    const src = t.source;
                    const map = {
                      AUTO_BOT: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30",
                      AUTO_TP: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
                      AUTO_SL: "bg-rose-500/15 text-rose-300 border-rose-500/30",
                    };
                    const cls = map[src] || "bg-white/5 text-slate-300 border-white/10";
                    return (
                      <span className={`text-[10px] font-mono uppercase tracking-wider px-2 py-1 rounded-full border ${cls}`}>{src}</span>
                    );
                  })()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
